import script from "./Maintenance.vue?vue&type=script&setup=true&lang=js"
export * from "./Maintenance.vue?vue&type=script&setup=true&lang=js"

import "./Maintenance.vue?vue&type=style&index=0&id=67c7874a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\PC\\Desktop\\Code-Project\\VA-OD-TP\\OD-Demo-Code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c7874a"]])

export default __exports__